import { LEVEL_PATTERN, OVERALL_PATTERN } from '../editor.constant';

export function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function convertEscapeSequencesToNewlines(text: string): string {
  return text
    .replaceAll(String.raw`\r\n`, '\n')
    .replaceAll(String.raw`\r`, '\n')
    .replaceAll(String.raw`\n`, '\n');
}

export function isLevelHeader(line: string): boolean {
  const trimmedLine = line.trim();

  return LEVEL_PATTERN.test(line) || OVERALL_PATTERN.test(line) || trimmedLine.endsWith(':');
}

export function convertNewlinesToBrTags(text: string): string {
  const normalizedText = convertEscapeSequencesToNewlines(text)
    .replaceAll('\r\n', '\n')
    .replaceAll('\r', '\n');

  return escapeHtml(normalizedText).replaceAll('\n', '<br>');
}
